import { render, staticRenderFns } from "./LeadBoardHeader.vue?vue&type=template&id=6dbc8c1e&"
import script from "./LeadBoardHeader.vue?vue&type=script&lang=js&"
export * from "./LeadBoardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports